<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
{{{text}}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{closeTourText}}</button>
	{{# if hasSteps}}
		<button type="button" class="btn btn-primary" data-dismiss="modal" id="js-start">{{TR "Mehr Details"}}</button>
	{{/if}}
</div>
